import { IconType } from "../../type/icon_type";
import React from "react";

const CariSymbol = (props: IconType) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="18" fill="#E3F2FF" />
      {/* 고트디자인 공식 심볼(logos/src/symbol.svg, 중심 24,24)을 원 중앙에 폭 26px 로 — 카리페이 로고의 파란 심볼과 같다 */}
      <g transform="translate(18 18) scale(0.7222) translate(-24 -24)">
        <path d="M37.9841 27.353C37.763 27.1955 37.7004 26.9029 37.8367 26.6732C38.378 25.759 39.6028 23.3512 40.1523 20.0823C40.7327 16.6279 39.6082 11.4206 34.9299 11.9695C32.6815 12.2325 30.6708 13.8506 29.4304 15.5129C28.7979 16.3601 28.3107 17.2358 27.9698 18.253C27.4146 19.9111 27.2373 21.6667 27.3091 23.4164L27.3075 23.4154C27.3075 23.4154 27.1614 35.4334 36.7268 36.0716L36.7214 36.0617C38.2458 36.1491 40.5732 35.5694 41.4715 34.1682C43.4801 31.0355 39.2051 28.2224 37.9841 27.3533V27.353Z" fill="#3B82F6" />
        <path d="M6.0444 16.2412C6.0444 16.2412 6.01931 16.421 6.00914 16.7438C5.97293 17.5649 6.04377 18.3873 6.23055 19.1789C6.70194 21.525 8.9147 24.9563 12.8841 27.8679C12.9832 27.9406 12.9965 28.088 12.913 28.1792C12.4994 28.6309 11.9159 29.1801 11.5426 29.6518C9.91085 31.714 8.32101 34.873 9.64243 37.4524C10.3076 38.7509 12.1433 39.3916 13.4959 39.4177C16.7181 39.4796 19.0585 38.2446 21.2656 35.8034C23.4717 33.3623 24.789 30.1477 25.3366 26.8473C26.0386 22.6197 25.4719 18.0652 23.2236 14.4668C20.9889 10.8914 16.4611 7.97343 12.2192 8.68878C8.7492 9.27389 6.44718 12.6003 6.05838 16.1062L6.0444 16.2412Z" fill="#3B82F6" />
      </g>
    </svg>
  );
};

export default CariSymbol;
